module.exports = "<p-growl [value]=\"msgs\" life=\"10000\"></p-growl>\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/_public-layout/public-layout.component.html
// module id = ./src/app/components/_public-layout/public-layout.component.html
// module chunks = main